/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_LIB_BALANCE_ITEM = {
  id: 'balance',
  screenId: 'acc-lib-balance',
  label: 'Balance',
  description: 'Balance de sumas y saldos del período.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Resumen por cuenta imputable: sumas de debe y haber del período y saldos deudores o acreedores.',
      },
      {
        title: 'Paso 1 — Filtrar',
        fields: [
          { label: 'Desde / Hasta', description: 'Período del balance. Tocá «Consultar».' },
        ],
      },
      {
        title: 'Paso 2 — Leer el informe',
        bullets: [
          'Por cuenta: clase, debe período, haber período, saldo deudor, saldo acreedor.',
          'Exportable a CSV y Excel.',
        ],
      },
    ],
  },
}
